<template>
  <b-card-actions noActions class="form-info-card">
    <div class="d-flex justify-content-between align-items-center flex-wrap mb-1">
      <h4 class="mb-0">Property Info</h4>
    </div>

    <validation-observer ref="observer" v-slot="{ validate }">
      <!-- Location -->
      <div class="form-section">
        <h6 class="form-section-title">
          <feather-icon icon="MapPinIcon" size="15" class="mr-50" />Location
        </h6>

        <b-row>
          <b-col md="12">
            <validation-provider
              v-slot="{ errors, valid, validated }"
              rules="required"
              name="place"
            >
              <label>Property Pin <span class="text-danger">*</span></label>

              <b-form-group :class="{
                    'is-invalid': errors.length,
                    'is-valid': validated && valid
                  }">
                <vue-autosuggest
                  ref="autocomplete"
                  v-model="placeQuery"
                  :suggestions="suggestions"
                  :input-props="{
                    ...inputProps,
                    class: [
                      inputProps.class,
                      errors.length ? 'is-invalid' : '',
                      validated && valid ? 'is-valid' : ''
                    ]
                  }"
                  :section-configs="sectionConfigs"
                  :render-suggestion="renderSuggestion"
                  :get-suggestion-value="getSuggestionValue"
                  @input="fetchResults"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col md="3">
            <label>Address No.</label>

            <b-form-group>
              <b-form-input
                v-model="input.addressNo"
                @input="emitToParent"
                placeholder="Address No."
              />
            </b-form-group>
          </b-col>

          <b-col md="3">
            <label>Unit</label>

            <b-form-group>
              <b-form-input
                v-model="input.units"
                @input="emitToParent"
                placeholder="Unit"
              />
            </b-form-group>
          </b-col>

          <b-col md="3">
            <label>Floor</label>

            <b-form-group>
              <b-form-input
                v-model="input.floors"
                @input="emitToParent"
                placeholder="Floor"
              />
            </b-form-group>
          </b-col>

          <b-col md="3">
            <label>Building</label>

            <b-form-group>
              <b-form-input
                    v-model="input.building"
                    @input="emitToParent"
                    placeholder="Building"
                  />
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <!-- Specifications -->
      <div class="form-section">
        <h6 class="form-section-title">
          <feather-icon icon="HomeIcon" size="15" class="mr-50" />Specifications
        </h6>

        <b-row>
          <b-col md="3">
            <label>Type</label>

            <b-form-group>
              <b-form-input
                v-model="input.type"
                @input="emitToParent"
                placeholder="Type"
              />
            </b-form-group>
          </b-col>

          <b-col md="3">
            <label>Area : sqm. (Marketing)</label>

            <validation-provider
              #default="{ errors }"
              rules="min:0"
              name="sqm"
            >
              <b-form-group>
                <b-form-input
                  v-model="input.sqm"
                  @input="emitToParent"
                  placeholder="sqm"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="6" md="3">
            <label>Bedroom</label>

            <b-form-group>
              <b-form-spinbutton
                v-model="input.bedroom"
                @input="emitToParent"
                min="0"
                size="sm"
                class="ml-75"
                inline
              />
            </b-form-group>
          </b-col>

          <b-col cols="6" md="3">
            <label>Bathroom</label>

            <b-form-group>
              <b-form-spinbutton
                v-model="input.bathroom"
                @input="emitToParent"
                size="sm"
                min="0"
                class="ml-75"
                inline
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <label>Direction</label>

            <b-form-group>
              <v-select
                v-model="input.direction"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                @input="emitToParent"
                :options="option_deriction"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <label>Furniture</label>

            <b-form-group>
              <v-select
                v-model="input.furniture"
                @input="emitToParent"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="name"
                :options="furnitures"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <label>Key</label>

            <b-form-group>
              <b-form-input
                v-model="input.key"
                @input="emitToParent"
                placeholder="Key"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <label>View</label>

            <b-form-group>
              <b-form-input
                v-model="input.view"
                @input="emitToParent"
                placeholder="View"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <!-- Listing status -->
      <div class="form-section">
        <h6 class="form-section-title">
          <feather-icon icon="ListIcon" size="15" class="mr-50" />Listing Status
        </h6>

        <b-row>
          <b-col md="6">
            <validation-provider
              v-slot="{ errors, valid, validated }"
              rules="required"
              name="action"
            >
              <label>Action <span class="text-danger">*</span></label>

              <b-form-group :class="{
                    'is-invalid': errors.length,
                    'is-valid': validated && valid
                  }">
                <div>
                  <!-- multi select ของ "ฝั่ง" (ขาย/เช่า) — payload ยังเป็น action เดียว ดู actionSides -->
                  <v-select
                    v-model="actionSides"
                    @input="emitToParent"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    multiple
                    :reduce="option => option.id"
                    :options="actionOptions"
                    :class="{
                      'is-invalid': errors.length,
                      'is-valid': validated && valid
                    }"
                  />
                </div>

                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col md="6">
            <label>Status</label>

            <b-form-group>
              <v-select
                v-model="input.status"
                @input="emitToParent"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="name"
                :options="statusOptions"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <label>Label</label>

            <b-form-group>
              <v-select
                v-model="input.label"
                @input="emitToParent"
                name="label_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="option"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <label>Score</label>

            <b-form-group>
              <b-form-input
                v-model="input.total_fbr_score"
                @input="emitToParent"
                placeholder="Score"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group>
              <label>Expire date</label>

              <b-form-datepicker
                id="expire_date"
                v-model="input.expire_date"
                reset-button
                close-button
                @input="emitToParent"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group>
              <label>Updated Date (expire date, price, status)</label>

              <b-form-datepicker
                id="available_date"
                v-model="input.available_date"
                reset-button
                close-button
                @input="emitToParent"
              />
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group class="mb-0">
              <label>Active</label>

              <b-form-checkbox
                checked="true"
                class="custom-control-primary"
                name="is_active"
                v-model="input.is_active"
                @change="emitToParent"
                switch
              />
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group class="mb-0">
              <label>Featured</label>

              <b-form-checkbox
                class="custom-control-primary"
                name="featured"
                v-model="input.featured"
                @change="emitToParent"
                switch
              />
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <!-- SEO & marketing (collapsed by default to reduce clutter) -->
      <div class="form-section">
        <button
          type="button"
          class="form-section-toggle"
          @click="showAdvanced = !showAdvanced"
        >
          <feather-icon icon="SearchIcon" size="15" class="mr-50" />
          SEO &amp; Marketing
          <feather-icon
            :icon="showAdvanced ? 'ChevronUpIcon' : 'ChevronDownIcon'"
            size="15"
            class="ml-auto"
          />
        </button>

        <b-collapse v-model="showAdvanced">
          <b-row class="pt-1">
            <b-col md="12">
              <b-tabs content-class="mt-1" v-if="langs.length > 0">
                <b-tab v-for="(lang, key) in langs" :key="'tab-' + key" :title="lang.name">
                  <b-row>
                    <b-col md="6">
                      <label>{{ `Meta Title (${lang.code})` }}</label>
                      <b-form-group>
                        <b-form-input
                          v-model="input.meta_title[lang.code]"
                          @input="emitToParent"
                          :placeholder="`Meta Title (${lang.code})`"
                        />
                      </b-form-group>
                    </b-col>

                    <b-col md="6">
                      <label>{{ `Meta Description (${lang.code})` }}</label>
                      <b-form-group>
                        <b-form-input
                          v-model="input.meta_description[lang.code]"
                          @input="emitToParent"
                          :placeholder="`Meta Description (${lang.code})`"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>
            </b-col>

            <b-col md="12">
              <label>Youtube URL</label>

              <b-form-group>
                <b-form-input
                  v-model="input.youtube"
                  :placeholder="`Youtube URL`"
                  @input="emitToParent"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-collapse>
      </div>

      <!-- Notes -->
      <div class="form-section">
        <h6 class="form-section-title">
          <feather-icon icon="MessageSquareIcon" size="15" class="mr-50" />Notes
        </h6>

        <b-row>
          <b-col md="12">
            <label>Property Comment.</label>

            <b-form-group>
              <b-form-textarea
                id="comment"
                v-model="input.comment"
                placeholder="comment"
                rows="3"
                v-on:input="emitToParent"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group class="mb-0">
              <label>Responsible By</label>

              <vue-autosuggest
                ref="autocomplete"
                v-model="saleUser"
                :suggestions="suggestions_sale"
                :input-props="inputProps"
                :section-configs="sectionConfigs"
                :render-suggestion="renderSaleSuggestion"
                :get-suggestion-value="getSaleSuggestionValue"
                @input="fetchSaleResults"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </validation-observer>
  </b-card-actions>
</template>

<script>
import { ref, onUnmounted, onMounted } from '@vue/composition-api'
import { VueAutosuggest } from 'vue-autosuggest'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BButton,BFormSpinbutton,
  BFormCheckbox,BFormTextarea,BOverlay, BTabs, BTab, BCollapse,
} from 'bootstrap-vue'
import { BCard, BCardText, BAvatar } from 'bootstrap-vue'
import axios from '@axios'
import { MIN_USER_KEYWORD, searchUsers } from '@core/utils/user-autocomplete'
import { MIN_PLACE_KEYWORD, searchPlaces } from '@core/utils/place-autocomplete'
import { codeAjax } from './code'
import vSelect from 'vue-select'
import BCardActions from '../../../@core/components/b-card-actions/BCardActions.vue'
import { BFormRating } from 'bootstrap-vue'
import { BFormDatepicker } from 'bootstrap-vue'
import furnitureStoreModule from '@/views/inventory-list/furnitureStoreModule'
import store from '@/store'
import languagesStoreModule from '../../languages/languagesStoreModule'

export default {
  inheritAttrs:true,
  components: {
    VueAutosuggest,
    BCardActions,
    BCard,
    BCardText,
    BAvatar,
    BFormRating,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    vSelect,
    BFormSpinbutton,
    BFormCheckbox,
    BFormTextarea,
    loading: true,
    BFormDatepicker,
    BTabs, BTab, BCollapse,
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale
    },

    /*
     * เลือกได้เฉพาะสถานะที่ทำให้ห้อง "ไม่ว่าง" — เว้นว่างไว้แปลว่าว่าง
     *
     * ⚠️ ห้องที่ถือสถานะเลิกใช้อยู่ (Sale with tenant / Not Sure) ต้องใส่กลับเข้าลิสต์ด้วย
     * ไม่งั้น v-select จะโชว์ช่องว่างทั้งที่ห้องมีสถานะ แล้วกดเซฟทีเดียวสถานะหายเงียบ ๆ
     */
    /** ให้เลือกได้เฉพาะฝั่งขาย/เช่า — "Sale & Rent" คือการเลือกทั้งสองอัน ไม่ใช่ตัวเลือกแยก */
    actionOptions() {
      return this.actions.filter(v => v.id == 3 || v.id == 4)
    },

    /**
     * แปลงไปกลับระหว่าง multi select กับ `input.action` ที่ API ยังรับเป็นค่าเดียว
     * (2 = Sale & Rent, 3 = Sale, 4 = Rent)
     *
     * ⚠️ setter ทำงานเฉพาะตอนผู้ใช้แตะช่องนี้ ห้องเก่าที่เป็น Unknown (action_id = 1) จึงไม่ถูก
     * ล้างเป็นค่าว่างเพียงเพราะเปิดฟอร์มขึ้นมาดู — getter คืน [] แต่ input.action ยังคงค่าเดิม
     */
    actionSides: {
      get() {
        const id = this.input.action && this.input.action.id

        if (id == 2) return [3, 4]

        return id == 3 || id == 4 ? [id] : []
      },
      set(ids) {
        const sale = ids.includes(3)
        const rent = ids.includes(4)
        const actionId = sale && rent ? 2 : sale ? 3 : rent ? 4 : null

        this.input.action = actionId ? this.actions.find(v => v.id == actionId) : null
      },
    },

    statusOptions() {
      const items = this.statuses.filter(v => this.selectableStatusIds.includes(v.id))
      const current = this.input.status

      if (current && !items.some(v => v.id === current.id)) items.unshift(current)

      return items
    },
  },
  watch:{
      parentData(){
      console.log('aavvv');
    }
  },
  data() {
    return {
      codeAjax,
      showAdvanced: false,
      originalAvailableDate: '',
      input:{
        comment:'',
        place_id: null,
        label: null,
        total_fbr_score:null,
        addressNo: null,
        units: null,
        floors: null,
        type: null,
        sqm: null,
        building: null,
        bedroom: 0,
        bathroom: 1,
        key: null,
        view: null,

        direction: null,
        furniture: null,
        action: null,
        status: null,

        sale_id:null,
        is_active: true,
        featured: false,
        expire_date:'',
        available_date:'',
        meta_title: {},
        meta_description: {},
        youtube: ''
      },
      dataP: this.parentData,

      name: '',
      place_id:'',
      featured:false,
      is_active:true,
      sale_id:'',
      type_id:'',
      datasuggest: [],
      filteredOptions: [],
      actions:[],
      expire_date:'',
      available_date:'',
      limit: 10,
      selected: null,

      furnitures:[],
      results: [],
      timeout: null,
      selected: null,
      suggestions_sale:[],
   
      option: [
        { id: 1, title: 'Best Rent' }, 
        { id: 2, title: 'Best Buy' }, 
        { id: 3, title: 'Reduced' }, 
        { id: 4, title: 'Sold' }, 
        { id:5, title:'Rented'}
      ],
      option_deriction: [
        { id: 1, title: 'North' }, 
        { id: 2, title: 'East' }, 
        { id: 3, title: 'South' }, 
        { id: 4, title: 'West' }, 
        { id:5, title:'North East'},
        { id:6, title:'North West'},
        { id:7, title:'South East'},
        { id:8, title:'South West'},
      ],
      /*
       * ฝั่งที่ "มีราคา" ครั้งล่าสุดที่รู้ — null = ยังไม่รู้ (ฟอร์มเพิ่มห้องใหม่ที่ยังไม่มีราคาอะไรเลย)
       * ใช้เทียบว่าราคาฝั่งไหนเพิ่งถูกใส่หรือถูกลบ ดู syncActionWithPrices
       */
      priceSides: null,
      // รายการเต็ม ไว้ "อ่าน" สถานะเดิมของห้อง — ที่ให้เลือกได้จริงดู statusOptions ด้านล่าง
      statuses:[
        { id: 1, name: 'Available now' }, 
        { id: 2, name: 'Rented' }, 
        { id: 3, name: 'Sale with tenant' },
        { id: 5, name: 'Own Stay' },
        { id: 6, name: 'Not Sure' },
        { id: 7, name: 'Cannot contact' },
        { id: 8, name: 'Follow up' },
        { id: 4, name: 'Sold' }
      ],
      // Available now (1) ไม่ให้เลือก — เว้นว่างไว้แล้ว API เติมให้เองถ้าห้องยังเปิด Active
      // ส่วน Sale with tenant (3) / Not Sure (6) เลิกใช้แล้ว
      selectableStatusIds: [2, 4, 5, 7, 8],
      debounceMilliseconds: 250,
      usersUrl: 'https://jsonplaceholder.typicode.com/users',
      photosUrl: 'https://jsonplaceholder.typicode.com/photos',
      inputProps: {
        id: 'autosuggest__input_ajax',
        placeholder: 'Property Pin',
        class: 'form-control',
        name: 'pin_id',
      },
      suggestions: [],
      sectionConfigs: {
        place: {
          limit: 20,
          label: 'Place',
          onSelected: selected => {
            this.input.place_id = selected.item.id;
            this.emitToParent();
          },
        },
        sale: {
          limit: 20,
          label: 'User',
          onSelected: selected => {
            this.input.sale_id = selected.item.id;
            this.emitToParent();
          },
        },
      },
      placeQuery: null,
      debounceMilliseconds: 400,
      timeout: null,
      saleUser: null
    }
  },
  props: {
    parentData: {
      type: Object,
    },
    id:{
      type: [String, Number]
    }
  },
  created() {
    this.fetchFurnitureList()
    this.fetchPropertyActionList()

    if(this.id){
      this.getData();
    }
  },
  setup(props) {
    const LANGUAGES_STORE_MODULE_NAME = "app-languages";
    const FURNITURE_APP_STORE_MODULE_NAME = 'app-furniture'

    if (!store.hasModule(FURNITURE_APP_STORE_MODULE_NAME)) {
      store.registerModule(FURNITURE_APP_STORE_MODULE_NAME, furnitureStoreModule);
    }

    if (!store.hasModule(LANGUAGES_STORE_MODULE_NAME)) {
      store.registerModule(LANGUAGES_STORE_MODULE_NAME, languagesStoreModule);
    }

    onUnmounted(() => {
      if (store.hasModule(FURNITURE_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(FURNITURE_APP_STORE_MODULE_NAME);
      }

      if (store.hasModule(LANGUAGES_STORE_MODULE_NAME)) {
        store.unregisterModule(LANGUAGES_STORE_MODULE_NAME);
      }
    });

    const inventoryData = ref([])
    const inventoryId = ref(null)
    const langs = ref([]);

    const fetchInventoryData = async () => {
      try {
        const response = await axios.post('property/v1/inventory/getInventory', { 
          propertyId: props.id
        })

        inventoryData.value = response.data.data || []
        inventoryId.value = inventoryData.value.length? inventoryData.value[0].id: null
      } catch(error) {
        console.error(error)
      }
    }

    const getLangs = ()=>{
      store.dispatch('app-languages/fetchData', { is_active: 1 })
        .then((res) => {
          if(res.data.success){
              langs.value = res.data.data;
          }  
        }
      )
    }

    onMounted(() => {
      fetchInventoryData()
      getLangs()
    })

      return {
        inventoryData,
        inventoryId,
        langs,
      }
  },
  methods: {
    /**
     * ใส่ราคาเช่า → ได้ action เช่า, ใส่ราคาขาย → ได้ action ขาย, ลบราคาออก → ถอด action นั้นทิ้ง
     * (id ของ property_action: 2 = Sale & Rent, 3 = Sale, 4 = Rent)
     *
     * ⚠️ แก้เฉพาะฝั่งที่ราคาเพิ่งเปลี่ยนเท่านั้น ฝั่งที่ผู้ใช้เลือกเองไว้ต้องไม่ถูกแตะ —
     * เช่นตั้ง Sale & Rent ไว้ทั้งที่ยังไม่ใส่ราคาเช่า ค่านั้นต้องอยู่จนกว่าจะไปยุ่งกับราคาเช่าจริง ๆ
     *
     * เรียกจาก PropertyForm.vue เพราะราคาอยู่คนละคอมโพเนนต์ (FormSale.vue)
     */
    syncActionWithPrices(hasSale, hasRent) {
      // ครั้งแรกคือการตั้งต้น ยังไม่มีอะไร "เปลี่ยน" ให้ตาม
      if (!this.priceSides) {
        this.priceSides = { sale: hasSale, rent: hasRent }

        return
      }

      const current = {
        sale: this.input.action && (this.input.action.id == 3 || this.input.action.id == 2),
        rent: this.input.action && (this.input.action.id == 4 || this.input.action.id == 2),
      }

      const next = {
        sale: hasSale !== this.priceSides.sale ? hasSale : !!current.sale,
        rent: hasRent !== this.priceSides.rent ? hasRent : !!current.rent,
      }

      this.priceSides = { sale: hasSale, rent: hasRent }

      if (next.sale === !!current.sale && next.rent === !!current.rent) return

      const actionId = next.sale && next.rent ? 2 : next.sale ? 3 : next.rent ? 4 : null

      this.input.action = actionId ? this.actions.find(v => v.id == actionId) : null
      this.emitToParent()
    },

    makeToast(variant = null, title, message) {
      this.$bvToast.toast(message, {
        title: title,
        variant,
        solid: true,
      })
    },
    async fetchFurnitureList () {
      try {
        const { data } = await axios.get('furnituretype/v1/list')

        if(data.success) {
          this.furnitures = data.data || [];
        }
      } catch(error) {
        const errMsg = error?.response?.data?.message || 'Something went wrong!'
        this.makeToast('danger', 'Error', errMsg)
      }
    },
    async fetchPropertyActionList () {
      try {
        const { data } = await axios.get('property-action/v1/list')

        if(data.success) {
          this.actions = data.data || []; 
        }
      } catch(error) {
        const errMsg = error?.response?.data?.message || 'Something went wrong!'
        this.makeToast('danger', 'Error', errMsg)
      }
    },
    async getData () {
      try {
        const { data } = await axios.get(`property/v1/getdetail/${this.id}`)

        if(data?.success) {
          const propertyData = data.data[0] || [];
          
          this.input.available_date = propertyData.availble_date? this.formatDate(propertyData.availble_date): null
          this.originalAvailableDate = this.input.available_date || ''
          this.input.expire_date = propertyData.expire_date? this.formatDate(propertyData.expire_date): null;
          
          this.input.featured = propertyData.is_highlight? true: false
          this.input.is_active = propertyData.is_active? true: false

          this.input.meta_title = propertyData.meta_title || {}
          this.input.meta_description = propertyData.meta_description || {}

          this.input.sale_id = propertyData.sale_id || null
          this.saleUser = propertyData.sale_firstname

          this.input.place_id = propertyData.place_id
          this.placeQuery = propertyData.place_name

          this.input.total_fbr_score = propertyData.total_fbr_score
          this.input.addressNo = propertyData.address_no
          this.input.units = propertyData.units
          this.input.floors = propertyData.floors
          this.input.type = propertyData.type_name
          this.input.sqm = propertyData.sqm
          this.input.building = propertyData.buildiing
          this.input.bedroom = propertyData.bedroom
          this.input.bathroom = propertyData.bathroom
          this.input.key = propertyData.note_roomkey
          this.input.view = propertyData.view_remark

          this.input.label = this.option.find(v => v.id == propertyData.label_id)
          this.input.direction = this.option_deriction.find(v => v.id == propertyData.direction_id)
          this.input.furniture = this.furnitures.find(v => v.id == propertyData.furniture_id)
          this.input.action = this.actions.find(v => v.id == propertyData.action_id)
          // จำ "ฝั่งที่มีราคา" ตอนเปิดฟอร์มไว้ เพื่อให้ syncActionWithPrices รู้ว่าอะไรเพิ่งเปลี่ยน
          this.priceSides = {
            sale: Number(propertyData.sale_price) > 0,
            rent: Number(propertyData.rent_price) > 0,
          }
          // Available now ไม่ใช่ตัวเลือกในฟอร์ม โหลดมาเป็นค่าว่าง แล้ว API เติมกลับให้ตอนเซฟ
          this.input.status = propertyData.status_id == 1
            ? null
            : this.statuses.find(v => v.id == propertyData.status_id)

          this.input.youtube = propertyData.youtube
          this.input.comment = propertyData.comment
        }
      } catch(error) {
        const errMsg = error?.response?.data?.message || 'Something went wrong!'
        this.makeToast('danger', 'Error', errMsg || 'Fetch failed')
      }
    },
    formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;

        return [year, month, day].join('-');
    },
    setIsActive(value) {
      this.input.is_active = value
      this.emitToParent()
    },
    setAvailableDateToToday() {
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      this.input.available_date = `${year}-${month}-${day}`
      this.emitToParent()
    },
    emitToParent(){
      this.$emit('childToParent', this.input)
    },
    fetchResults() {
      // Unpaged, this endpoint answers a 2-character keyword with 6.3 MB after 17 s; see place-autocomplete.js
      if (!this.placeQuery || this.placeQuery.trim().length < MIN_PLACE_KEYWORD) {
        this.suggestions = []
        return
      }

      clearTimeout(this.timeout)
      this.timeout = setTimeout(this.fetchPlaceAutocomplete, this.debounceMilliseconds)
    },
    async fetchPlaceAutocomplete() {
      try {
        this.suggestions = [
          {
            name: 'place',
            data: await searchPlaces(this.placeQuery),
          },
        ]
      } catch (err) {
        console.error(err)
      }
    },
    renderSuggestion(suggestion) {
      return suggestion.item.name[this.currentLocale]
    },
    getSuggestionValue(suggestion) {
      const { name, item } = suggestion
      
      return name === 'hotels' ? item.title : item.name[this.currentLocale]
    },
    fetchSaleResults() {
      // One character matches ~6,000 users and the endpoint returns all of them; see user-autocomplete.js
      if (!this.saleUser || this.saleUser.trim().length < MIN_USER_KEYWORD) {
        this.suggestions_sale = []
        return
      }

      clearTimeout(this.timeout)
      this.timeout = setTimeout(this.fetchSaleAutocomplete, this.debounceMilliseconds)
    },
    async fetchSaleAutocomplete() {
      try {
        this.suggestions_sale = [
          {
            name: 'sale',
            data: await searchUsers(this.saleUser),
          },
        ]
      } catch (err) {
        console.error(err)
      }
    },
    renderSaleSuggestion(suggestion) {
      
      return suggestion.item.owner_firstname
    },
    getSaleSuggestionValue(suggestion) {
      const { name, item } = suggestion
       
      return name === 'hotels' ? item.title : item.owner_firstname
    },
    async validateForm() {
      const valid = await this.$refs.observer.validate()
      return valid
    },
  },
}
</script>

<style>
/* .is-invalid input {
  border-color: #dc3545 !important;
} */

/* Make vue-select match Bootstrap validation style */
.v-select.is-invalid .vs__dropdown-toggle {
  border-color: #ea5455;
}

.v-select.is-valid .vs__dropdown-toggle {
  border-color: #28c76f;
}
</style>

<style scoped>
.form-section {
  margin-bottom: 1.5rem;
}

.form-section-title {
  display: flex;
  align-items: center;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.8rem;
  letter-spacing: 0.02em;
  color: var(--secondary, #82868b);
  padding-bottom: 0.5rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.form-section-toggle {
  display: flex;
  align-items: center;
  width: 100%;
  background: transparent;
  border: none;
  padding: 0.5rem 0;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.8rem;
  letter-spacing: 0.02em;
  color: var(--secondary, #82868b);
  cursor: pointer;
}

.form-section-toggle:hover {
  color: var(--primary, #7367f0);
}

.dark-layout .form-section-title {
  border-bottom-color: rgba(255, 255, 255, 0.08);
}

.form-group.is-invalid {
  border-left: 3px solid #ea5455;
  background-color: rgba(234, 84, 85, 0.06);
  border-radius: 0.357rem;
  padding: 0.75rem 0.75rem 0.5rem;
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}
</style>